import CloseIcon from '@mui/icons-material/Close';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export const ActionButtons = ({
  index = null,
  fields = null,
  append,
  remove,
}: {
  index?: number | null;
  fields?: Record<'id', string>[] | null;
  append?: () => void;
  remove?: () => void;
}) => {
  if (index !== null && fields) {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1.875rem 1.875rem',
          alignItems: 'center',
          justifyItems: 'center',
        }}
      >
        <div
          style={{
            width: '1.25rem',
            margin: '0 0.3125rem',
            gridColumnStart: '1',
          }}
        >
          {index !== 0 ? (
            <CloseIcon
              data-testid="remove-role-priority"
              style={{ cursor: 'pointer', color: '#E31B0C' }}
              onClick={remove}
            />
          ) : null}
        </div>
        <div style={{ margin: '0 0.3125rem', gridColumnStart: '2' }}>
          {index === fields.length - 1 ? (
            <AddCircleOutlineIcon
              data-testid="add-role-priority"
              style={{
                cursor: 'pointer',
                backgroundColor: 'white',
                color: '#3F51B5',
              }}
              onClick={append}
            />
          ) : null}
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1.875rem 1.875rem',
        alignItems: 'center',
        justifyItems: 'center',
      }}
    >
      <div
        style={{
          width: '1.25rem',
          margin: '0 0.3125rem',
          gridColumnStart: '1',
        }}
      >
        <CloseIcon
          style={{ cursor: 'pointer', color: '#E31B0C' }}
          onClick={remove}
        />
      </div>
      <div style={{ margin: '0 0.3125rem', gridColumnStart: '2' }}>
        <AddCircleOutlineIcon
          style={{ cursor: 'pointer', backgroundColor: 'white' }}
          onClick={append}
        />
      </div>
    </div>
  );
};
